import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getAnnouncement: ['announceId'],
  getAnnouncementSuccess: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  // 讨论内容
  announcementContent: {},
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_ANNOUNCEMENT_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    announcementContent: action.announcementContent,
  }),

});
